import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { report_billing } from "../../../components/Report.js";
export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_view: false,
      data_customer: [],
      data_invoice: [],

      credit_note: [],

      billing_document_no: "",
      date: format_date(new Date(), "yyyy-mm-dd", "en"),
      due_date: format_date(
        new Date(new Date().setMonth(new Date().getMonth() + 1)),
        "yyyy-mm-25",
        "en"
      ),
      customer_id: "",
      address: "",
      phone: "",
      ref_no: "",
      filter_month: "",
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    if (params("id")) {
      await this.GetByID(params("id"));
    }

    loading(false);
  }

  Get = async () => {
    let data_customer;
    let [result_customer] = await Promise.all([
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
    ]);
    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
        phone: e.phone,
        address: e.address,
      }));
    }
    this.setState({
      data_customer,
    });
  };
  GetInvoice = async (id) => {
    loading(true);
    let [result] = await Promise.all([
      GET("admin/invoices/list", {
        page: 0,
        data_search: "",
        customer_id: id,
        status_code: ""
      }),
    ]);
    if (result?.status) {
      this.setState({
        data_invoice: result.data.filter((e) => e.status === "รอชำระ"),
      });
    }
    loading(false);
  };
  GetByID = async (id) => {
    const { data_product } = this.state;
    loading(true);
    let result = await GET("admin/billing-notes/list", { uid: id });
    let item = result.data;
    this.setState({
      ...item,
      uid: item.uid,
      sale_uid: item.sale.uid || "",
      date: item.created_at ? item.created_at.split("T")[0] : "",
      due_date: item.sale.due_date
        ? item.sale.due_date
        : item.sale.payment_type === "ชำระเงินเชื่อ"
        ? format_date(
            new Date(
              new Date(item.created_at).setMonth(
                new Date(item.created_at).getMonth() + 1
              )
            ),
            "yyyy-mm-25",
            "en"
          )
        : format_date(new Date(), "yyyy-mm-dd", "en"),
      // customer
      customer_id: item.sale.customer.uid,
      payment_terms: item.sale.customer.payment_conditions,
      address: item.sale.customer.address,
      phone: item.sale.customer.phone,
      tax_number: item.sale.customer.tax_number,

      withdrawal_type: item.sale.withdrawal_type,
      payment_type: item.sale.payment_type,
      receipt_type: item.sale.receipt_type,

      transaction_list: item.sale.transaction_list,
      transaction_list_vat: item.sale.transaction_list_vat?.map((e) => ({
        ...e,
        product_id:
          data_product.find((p) => p.product_code === e.product_code)?.value ||
          "",
      })),
      credit_note: item.credit_note || [],
      is_vat: item.sale.is_vat,
      discount: item.sale.discount,

      amount_deposit: Number(item.sale.amount_deposit),
      total_pay: Number(item.sale.total_pay),
    });

    loading(false);
  };
  CreateUpdate = async () => {
    const { data_invoice, address, phone, ref_no } = this.state;

    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการออกใบวางบิลหรือไม่",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let selected = data_invoice.filter(
        (e) => e.checked && e.status === "รอชำระ"
      );
      let _total = 0;
      for (let item of selected) {
        if(item.sale){
          _total += Number(item.sale?.amount_net || 0);
        }else if(item.repair){
          _total += Number(item.repair?.amount_net || 0); 
        }
      }
      let body = {
        due_date: format_date(
          new Date(new Date().setMonth(new Date().getMonth() + 1)),
          "yyyy-mm-25",
          "en"
        ),
        address: address,
        phone: phone,
        amount: _total,
        status: "รอชำระ",
        invoice_list: selected.map((e) => e.uid),
      };

      let result = await POST("admin/billing-notes/create", body);
      if (result?.status) {
        alert("#", "success");
         report_billing(result.data);
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_view,
      billing_document_no,
      credit_note,
      data_customer,
      data_invoice,

      date,
      due_date,
      customer_id,
      address,
      phone,
      ref_no,
      filter_month,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="d-flex justify-content-between mb-2">
            <h4 className="fw-bold mb-3 me-3">สร้างใบวางบิล</h4>
            
          </div>
          {/* รายการสินค้า */}
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row mb-3">
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ผู้ติดต่อ</div>
                <Select
                  options={data_customer}
                  className="form-control"
                  placeholder="ชื่อลูกค้า..."
                  onChange={(e, i) => {
                    this.setState(
                      { customer_id: e, address: i.address, phone: i.phone },
                      () => {
                        this.GetInvoice(e);
                      }
                    );
                  }}
                  value={customer_id}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ที่อยู่</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ที่อยู่..."
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                  value={address}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เบอร์โทรศัพท์</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เบอร์โทรศัพท์..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ phone: e.target.value });
                  }}
                  value={phone}
                  maxLength={10}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <span className="wpx-150">เอกสารอ้างอิง</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เอกสารอ้างอิง..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ ref_no: e.target.value });
                  }}
                  value={ref_no}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่ออก</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="วันที่ออก..."
                  onChange={(e) => {
                    this.setState({ date: e.target.value });
                  }}
                  value={date}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่ครบกำหนด</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="วันที่ครบกำหนด..."
                  onChange={(e) => {
                    this.setState({ due_date: e.target.value });
                  }}
                  value={due_date}
                />
              </div>
            </div>
            <hr />
            <input
              type="month"
              className="form-control wpx-200 mb-3"
              onChange={(e) => {
                this.setState({ filter_month: e.target.value });
              }}
              value={filter_month}
            />
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td>
                      {" "}
                      <input
                        type="checkbox"
                        checked={data_invoice
                          ?.filter((e) => e.status !== "เสร็จสิ้น")
                          .every((e) => e.checked)}
                        onChange={(e) => {
                          this.setState(
                            {
                              data_invoice: data_invoice?.filter(e=>e.sale || e.repair).map((t) => {
                                return t.status === "เสร็จสิ้น"
                                  ? t
                                  : {
                                      ...t,
                                      checked: e.target.checked,
                                    };
                              }),
                            },
                            () => {
                              let date = data_invoice.find((t) => t.checked)?.sale?.created_at || data_invoice.find((t) => t.checked)?.repair?.created_at;
                              date = date ? new Date(date) : new Date();
                              this.setState({
                                due_date: format_date(
                                  new Date(
                                    date.getFullYear(),
                                    date.getMonth() + 1,
                                    25
                                  ),
                                  "yyyy-mm-dd",
                                  "en"
                                ),
                              });
                            }
                          );
                        }}
                      />
                    </td>
                    <td className="text-nowrap">วันที่ส่งสินค้า</td>
                    <td className="text-nowrap">รหัสเอกสาร</td>
                    <td className="text-nowrap">กำหนดชำระ</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">ประเภท Vat</td>
                    <td className="text-nowrap text-end">จำนวนเงิน (บาท)</td>
                    <td className="text-nowrap text-end">ลดหนี้</td>
                    <td className="text-nowrap text-end">มูลค่าหลังลดหนี้</td>
                    <td className="text-nowrap text-end">ชำระแล้ว</td>
                    <td className="text-nowrap text-end">ค้างชำระ</td>
                    <td className="text-nowrap text-end">ยอดเงินคืนลูกค้า</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data_invoice?.filter((item) => {
                    if (!filter_month) return true;
                    const itemDate = item.created_at || item.sale?.created_at || item.repair?.created_at;
                    if (!itemDate) return false;
                    const itemMonth = format_date(itemDate, "yyyy-mm", "en");
                    return itemMonth === filter_month;
                  })?.map((item, index) => (
                    <>
                    {item.sale ? (
                    <tr>
                      <td>
                        {item.status === "รอชำระ" && (
                          <input
                            type="checkbox"
                            checked={item.checked}
                            onChange={(e) => {
                              data_invoice[index].checked = e.target.checked;
                              let date = data_invoice.find((t) => t.checked)
                                ?.sale?.created_at;
                              date = date ? new Date(date) : new Date();
                              this.setState({
                                data_invoice,
                                due_date: format_date(
                                  new Date(
                                    date.getFullYear(),
                                    date.getMonth() + 1,
                                    25
                                  ),
                                  "yyyy-mm-dd",
                                  "en"
                                ),
                              });
                            }}
                          />
                        )}
                      </td>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">{item.document_no || ""}</td>
                      <td className="text-nowrap">
                        {item.sale?.due_date
                          ? format_date(item.sale?.due_date)
                          : format_date(new Date())}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.customer?.full_name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.receipt_type || ""}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed((item.sale?.receipt_type === "ต้องการ Vat" ? 1.07 : 1) * item.sale?.amount_net)}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(total(item.credit_note.filter(e=>e.status !== "ยกเลิก"), "amount"))}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed((item.sale?.receipt_type === "ต้องการ Vat" ? 1.07 : 1) * (item.sale?.amount_net-total(item.credit_note.filter(e=>e.status !== "ยกเลิก"), "amount")))}
                      </td>

                      <td className="text-nowrap text-end">{toFixed(Number(item.sale?.total_pay))}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(((item.sale?.receipt_type === "ต้องการ Vat" ? 1.07 : 1) * (item.sale?.amount_net-total(item.credit_note.filter(e=>e.status !== "ยกเลิก"), "amount"))) - Number(item.sale?.discount) - Number(item.sale?.total_pay))}
                        
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          (((item.sale?.receipt_type === "ต้องการ Vat" ? 1.07 : 1) * (item.sale?.amount_net-total(item.credit_note.filter(e=>e.status !== "ยกเลิก"), "amount"))) - Number(item.sale?.discount) - Number(item.sale?.total_pay)) < 0 ?
                          (((item.sale?.receipt_type === "ต้องการ Vat" ? 1.07 : 1) * (item.sale?.amount_net-total(item.credit_note.filter(e=>e.status !== "ยกเลิก"), "amount"))) - Number(item.sale?.discount) - Number(item.sale?.total_pay)) : 
                          0
                        )}
                      </td>
                      <td className="text-nowrap">{item.status}</td>
                      <td className="text-nowrap">
                        <BtnIcon
                          type="view"
                          onClick={() => {
                            this.setState({
                              billing_document_no: item.document_no,
                              credit_note: item.credit_note,
                              modal_create: false,
                              modal_view: true,
                            });
                          }}
                        />
                      </td>
                    </tr>
                    ): item.repair ? (
                      <tr>
                      <td>
                        {item.status === "รอชำระ" && (
                          <input
                            type="checkbox"
                            checked={item.checked}
                            onChange={(e) => {
                              data_invoice[index].checked = e.target.checked;
                              let date = data_invoice.find((t) => t.checked)
                                ?.repair?.created_at;
                              date = date ? new Date(date) : new Date();
                              this.setState({
                                data_invoice,
                                due_date: format_date(
                                  new Date(
                                    date.getFullYear(),
                                    date.getMonth() + 1,
                                    25
                                  ),
                                  "yyyy-mm-dd",
                                  "en"
                                ),
                              });
                            }}
                          />
                        )}
                      </td>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">{item.document_no || ""}</td>
                      <td className="text-nowrap">
                        {item.repair?.due_date
                          ? format_date(item.repair?.due_date)
                          : format_date(new Date())}
                      </td>
                      <td className="text-nowrap">
                        {item.repair?.customer?.full_name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.repair?.receipt_type || ""}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          item.repair?.receipt_type === "ต้องการ Vat"
                            ? item.repair?.amount_net * 1.07
                            : item.repair?.amount_net
                        )}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(total(item.credit_note, "amount"))}
                      </td>

                      <td className="text-nowrap text-end">{toFixed(item.repair?.total_pay)}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          item.repair?.receipt_type === "ต้องการ Vat"
                            ? (Number(item.repair?.amount_net) * 1.07) - Number(item.repair?.discount) -
                                total(item.credit_note, "amount")
                            : Number(item.repair?.amount_net) - Number(item.repair?.discount) -
                                total(item.credit_note, "amount")
                        )}
                      </td>
                      <td className="text-nowrap text-end">{
                        toFixed((
                          item.repair?.receipt_type === "ต้องการ Vat"
                            ? ((item.repair?.amount_net-(total(item.credit_note, "amount"))) * 1.07)
                            : (item.repair?.amount_net-(total(item.credit_note, "amount")))
                        ) - Number(item.repair?.amount_net) -Number((item.repair?.total_pay)) < 0 ? (
                          item.repair?.receipt_type === "ต้องการ Vat"
                            ? ((item.repair?.amount_net-(total(item.credit_note, "amount"))) * 1.07)
                            : (item.repair?.amount_net-(total(item.credit_note, "amount")))
                        ) - Number(item.repair?.amount_net) -Number((item.repair?.total_pay)) : 0)
                        }</td>
                      <td className="text-nowrap">{item.status}</td>
                      <td className="text-nowrap">
                        <BtnIcon
                          type="view"
                          onClick={() => {
                            this.setState({
                              billing_document_no: item.document_no,
                              credit_note: item.credit_note,
                              modal_create: false,
                              modal_view: true,
                            });
                          }}
                        />
                      </td>
                    </tr>
                    ): null}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          className="position-fixed w-100 bg-white d-flex justify-content-end p-3"
          style={{ bottom: 0, left: 0 }}
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              this.CreateUpdate();
            }}
          >
            สร้างใบวางบิล
          </button>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_view}
          onHide={() => this.setState({ modal_view: false })}
          fullscreen={true}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">ใบลดหนี้ : {billing_document_no}</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">เลขที่</td>
                    <td className="text-nowrap">วันที่ออก</td>
                    <td className="text-nowrap">จำนวน</td>
                    <td className="text-nowrap">จำนวนเงินที่ลดหนี้</td>
                    <td className="text-nowrap">เหตุผล</td>
                  </tr>
                </thead>
                <tbody>
                  {credit_note?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{item.document_no}</td>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">{item.count_item || 0}</td>
                      <td className="text-nowrap">{toFixed(item.amount)}</td>
                      <td className="text-nowrap">{item.reason || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
